import o from "./novoui-vuejs89.js";
/* empty css               */
import r from "./novoui-vuejs82.js";
const m = /* @__PURE__ */ r(o, [["__scopeId", "data-v-625c9adb"]]);
export {
  m as default
};
